import type { FigmaIconProps } from './types';

export const IconFigmaGrid = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.06641 2.66667C6.06641 2.62985 6.03682 2.60026 6 2.60026H2.66667C2.62985 2.60026 2.60026 2.62985 2.60026 2.66667V6C2.60026 6.03682 2.62985 6.06641 2.66667 6.06641H6C6.03682 6.06641 6.06641 6.03682 6.06641 6V2.66667ZM7.26693 6C7.26693 6.69956 6.69956 7.26693 6 7.26693H2.66667C1.96711 7.26693 1.39974 6.69956 1.39974 6V2.66667C1.39974 1.96711 1.96711 1.39974 2.66667 1.39974H6C6.69956 1.39974 7.26693 1.96711 7.26693 2.66667V6Z"
      fill={color}
    />
    <path
      d="M13.3997 2.66667C13.3997 2.62985 13.3702 2.60026 13.3333 2.60026H10C9.96318 2.60026 9.93359 2.62985 9.93359 2.66667V6C9.93359 6.03682 9.96318 6.06641 10 6.06641H13.3333C13.3702 6.06641 13.3997 6.03682 13.3997 6V2.66667ZM14.6003 6C14.6003 6.69956 14.0329 7.26693 13.3333 7.26693H10C9.30044 7.26693 8.73307 6.69956 8.73307 6V2.66667C8.73307 1.96711 9.30044 1.39974 10 1.39974H13.3333C14.0329 1.39974 14.6003 1.96711 14.6003 2.66667V6Z"
      fill={color}
    />
    <path
      d="M13.3997 10C13.3997 9.96318 13.3702 9.93359 13.3333 9.93359H10C9.96318 9.93359 9.93359 9.96318 9.93359 10V13.3333C9.93359 13.3702 9.96318 13.3997 10 13.3997H13.3333C13.3702 13.3997 13.3997 13.3702 13.3997 13.3333V10ZM14.6003 13.3333C14.6003 14.0329 14.0329 14.6003 13.3333 14.6003H10C9.30044 14.6003 8.73307 14.0329 8.73307 13.3333V10C8.73307 9.30044 9.30044 8.73307 10 8.73307H13.3333C14.0329 8.73307 14.6003 9.30044 14.6003 10V13.3333Z"
      fill={color}
    />
    <path
      d="M6.06641 10C6.06641 9.96318 6.03682 9.93359 6 9.93359H2.66667C2.62985 9.93359 2.60026 9.96318 2.60026 10V13.3333C2.60026 13.3702 2.62985 13.3997 2.66667 13.3997H6C6.03682 13.3997 6.06641 13.3702 6.06641 13.3333V10ZM7.26693 13.3333C7.26693 14.0329 6.69956 14.6003 6 14.6003H2.66667C1.96711 14.6003 1.39974 14.0329 1.39974 13.3333V10C1.39974 9.30044 1.96711 8.73307 2.66667 8.73307H6C6.69956 8.73307 7.26693 9.30044 7.26693 10V13.3333Z"
      fill={color}
    />
  </svg>
);
